import React, { useEffect, useState } from 'react'
import CustomTable from '../../customControl/CustomTable';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loaderActions } from '../../_actions/loader.actions';
import { ClearLocalStorage } from '../commonClass/Session';
import { getAllData, verifytoken } from '../../services/ApiCallingUserServices';
import CommonFilter from '../../customControl/CommonFilter';
import { formatDate } from '../commonClass/CommonValidation';

const NotificationTemplatelist = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [listdata, setListData] = useState([]);
    const [searchvalue, setSearchValue] = useState();
    const [searchby, setSerachBy] = useState('All');
    const [searchDisabled, setSearchDisabled] = useState(false);
    const [filterList, setFilterItems] = useState([]);
    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    useEffect(() => {
        let pagelink = user?.find(x => {
            if (x.PageLink === window.location.pathname)
                return x.MenuId
        });
        let mid = user?.find(x => x.MenuId === pagelink.MenuId);

        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);
        });
    }, [user])


    const getDataList = async () => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const listdata = await getAllData("/master/v1/getnotificationtemplatelist");
            listdata?.data?.map((obj, index) => {
                obj.SqNo = index+1
                obj.Active = obj?.isActive === true ? "Active" : "InActive"
                obj.CreatedDate = formatDate(obj?.CreatedOnDate)
            })
            setListData(listdata?.data);
            setFilterItems(listdata?.data)
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }

    const columns = [
        {
            name: 'Sq. No',
            sortable: true,
            float: "left",
            reorder: true,
            key: 'SqNo',
            selector: (el) => el?.SqNo
        },
        {
            name: 'Temp ID',
            sortable: true,
            float: "left",
            reorder: true,
            key: 'templateCode',
            selector: (el) => el?.templateCode
        },
        {
            name: 'Type',
            sortable: true,
            float: "left",
            reorder: true,
            key: 'notificationTypeName',
            selector: (el) => el?.notificationTypeName
        },
        {
            name: 'Title',
            sortable: true,
            float: "left",
            reorder: true,
            key: 'title',
            selector: (el) => el?.title
        },
        {
            name: 'Channel',
            sortable: true,
            float: "left",
            reorder: true,
            key: 'channelName',
            selector: (el) => el?.channelName
        },
        {
            name: 'Status',
            sortable: true,
            float: "left",
            key: 'Active',
            selector: (el) => el?.Active
        },
        {
            name: 'Edit',
            selector: (el) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditTrip(el?.notificationTemplateId)}></i></button>
        },
        {
            name: 'View',
            selector: (el) => <i className="fa fa-eye" onClick={() => handleViewTrip(el?.notificationTemplateId)}></i>
        }
    ];

    const handleCreate = () => {
        navigate('/ManageNotificationRule', { state: { disabled: false, editdisabled: false, viewtype: 'Add', id: 0 } });
    }

    const handleEditTrip = (id) => {
        setSearchDisabled(true);
        navigate('/ManageNotificationRule', { state: { disabled: false, editdisabled: true, viewtype: 'Update', id: id } });
    }

    const handleViewTrip = (id) => {
        setSearchDisabled(true);
        navigate('/ManageNotificationRule', { state: { disabled: true, editdisabled: true, viewtype: 'View', id: id } });
    }

    useEffect(() => {
        getDataList();
    }, [])

    return (
        <>
            <div class="container-fluid mt-4 heading_color">
                <h3>Notification Template List</h3>
            </div>
            <div class="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div class="d-flex justify-content-start ms-lg-3">
                        <button type="button" disabled={!useradd} class="btn btn-primary mx-1" id="btnAdd" onClick={handleCreate} >Create Template</button>
                    </div>
                    <br />
                    <CommonFilter
                        columns={columns}
                        filterList={filterList}
                        searchDisabled={searchDisabled}
                        getdata={getDataList}
                        setlistdata={setListData}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={listdata}
                        PdfExport={false}
                        ExportToExcel={false}
                        disabled={!userexport}
                    />
                </form>
            </div>
        </>
    )
}

export default NotificationTemplatelist